<page-toolbar [title]="package?.title"></page-toolbar>

<page-content [noPadding]="true">
  <data-table *ngIf="chats?.length" [plainData]="chats" [columns]="columns" [newHeader]="true" (remove)="deleteGroup($event)"
              [searchAll]="true" (custom)="addAdmin($event)" icon="person_add"></data-table>
</page-content>
